import { domain as isDomain } from '@/utils/Validators/validation';

const defaultErrors = {
  startOrEndWithHyphen: false,
  twoHyphensInARow: false,
  lessThanThreeCharacters: false,
  hasSpecialChars: false,
  invalidDomain: false,
};

const domainStartOrEndWithHyphen = domainSld => domainSld.startsWith('-') || domainSld.endsWith('-');
const domainHasTwoHyphensInARow = domainSld => domainSld.includes('--');
const domainHasLessThanThreeCharacters = domainSld => domainSld.length < 3;
const domainHasSpecialChars = domainSld => !domainSld.match(/^[a-z0-9-]*$/);

const domainVerification = (domainSld, domainTld) => {
  const domain = domainSld + domainTld;
  const errors = { ...defaultErrors };

  if (domainSld) {
    const startOrEndWithHyphen = domainStartOrEndWithHyphen(domainSld);
    const twoHyphensInARow = domainHasTwoHyphensInARow(domainSld);
    const lessThanThreeCharacters = domainHasLessThanThreeCharacters(domainSld);
    const hasSpecialChars = domainHasSpecialChars(domainSld);
    const domainIsValid = isDomain(domain);

    errors.startOrEndWithHyphen = startOrEndWithHyphen;
    errors.twoHyphensInARow = twoHyphensInARow;
    errors.lessThanThreeCharacters = lessThanThreeCharacters;
    errors.hasSpecialChars = hasSpecialChars;
    errors.invalidDomain = !domainIsValid;
  }

  return errors;
};

const domainValidator = {
  defaultErrors,
  domainStartOrEndWithHyphen,
  domainHasTwoHyphensInARow,
  domainHasLessThanThreeCharacters,
  domainHasSpecialChars,
  domainVerification,
};

export default domainValidator;
